import { init } from '@sentry/browser';

const BUILD_TARGET = process.env.STAGE;

const beforeSend = event => {
  if (BUILD_TARGET === 'master') {
    console.log('%cSentry log:', 'background: #6c5fc7; color: #fff', event);
    return null;
  }
  return event;
};

const configure = () => init({
  environment: BUILD_TARGET,
  dsn: process.env.SENTRY,
  beforeSend,
});


if (BUILD_TARGET !== 'dev') {
  configure();
}



// WEBPACK FOOTER //
// ./src/assets/js/utils/sentry.js